import {
  ArtifactContent,
  ContentBlock,
  ReferencesDict,
  ReferenceType,
} from '../../../../../../../../../../backend/src/types/types';

/**
 * Convert content blocks (from artifacts or messages) into markdown with [n] style references,
 * and build a ReferencesDict mapping ref keys to their IDs and types.
 */
export function buildExportContent(
  content: (ContentBlock | ArtifactContent)[],
  referenceIndexMap: Map<string, { index: number; referenceType: ReferenceType }>,
): { markdown: string; references: ReferencesDict } {
  const references: ReferencesDict = {};

  const markdown = content
    .map((block) => {
      if (block.type === 'text') return block.value;
      if (block.type === 'artifact') return '';
      const entry = referenceIndexMap.get(block.id);
      const index = entry?.index ?? 0;
      const refKey = String(index);
      if (block.refType === 'fact' || block.refType === 'chunk') {
        references[refKey] = { id: block.id, type: block.refType };
      }
      return `[${index}]`;
    })
    .join('');

  return { markdown, references };
}
